import $ from 'cash-dom'

const updateTrademark = () => {
  const elements = $('.metafield-rich_text_field p, .trademark-device')
  const replacements = [
    {
      pattern: /Pura Car Pro(?!™)/g,
      replacement: 'Pura Car Pro<span class="trademark -mr-1">™</span>',
    },
    {
      pattern: /Pura Car(?! Pro)(?!™)/g,
      replacement: 'Pura Car<span class="trademark -mr-1">™</span>',
    },
    {
      pattern: /Pura Plus(?!™)/g,
      replacement: 'Pura Plus<span class="trademark -mr-1">™</span>',
    },
    {
      pattern: /Pura 4(?!™)/g,
      replacement: 'Pura 4<span class="trademark -mr-1">™</span>',
    },
    {
      pattern: /Pura Mini(?!™)/g,
      replacement: 'Pura Mini<span class="trademark -mr-1">™</span>',
    },
  ]

  elements.each(function updateTM() {
    let html = $(this).html()
    replacements.forEach(({ pattern, replacement }) => {
      html = html.replace(pattern, replacement)
    })
    $(this).html(html)

    $(this)
      .find('.trademark')
      .each(function () {
        const parentFontSize = parseFloat(
          window.getComputedStyle(this.parentElement).fontSize
        )
        const size = Math.max(12, parentFontSize * 0.4)
        let topOffset = -1

        if (size <= 12) topOffset = -0.6
        else if (size >= 20) topOffset = -1.1

        $(this).css({
          fontSize: `${size}px`,
          top: `${topOffset}em`,
        })
      })
  })
}

updateTrademark()

export { updateTrademark }
